export const IT = (props: React.ComponentPropsWithoutRef<'svg'>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 32 24"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_9104_10906)">
      <path
        clipRule="evenodd"
        d="M0 0H32V24H0V0Z"
        fill="white"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M0 0H10.665V24H0V0Z"
        fill="#009246"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M21.335 0H32V24H21.335V0Z"
        fill="#CE2B37"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="clip0_9104_10906">
        <rect fill="white" height="24" width="32" />
      </clipPath>
    </defs>
  </svg>
)
